import React from "react";
import Modal from "react-modal";

interface ModalWindowProps {
  isOpenModal: boolean;
  closeModal: () => void;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const overlayStyle: React.CSSProperties = {
  zIndex: 1000,
  backgroundColor: "rgba(30, 42, 56, 0.6)",
  backdropFilter: "blur(4px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
};

const modalStyle: React.CSSProperties = {
  position: "relative",
  inset: "auto",
  background: "#FFFFFF",
  border: "1px solid #EDEDED",
  boxShadow: "0px 24px 48px rgba(0, 0, 0, 0.16), 0px 4px 8px rgba(0, 0, 0, 0.06)",
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxHeight: "calc(100dvh - 40px)",
  maxWidth: "calc(100vw - 40px)",
  overflowY: "auto",
  overflowX: "hidden",
  boxSizing: "border-box",
};

const ModalWindow: React.FC<ModalWindowProps> = ({
  children,
  isOpenModal,
  closeModal,
  style,
}) => {
  return (
    <Modal
      isOpen={isOpenModal}
      contentLabel="Modal Window"
      style={{
        overlay: overlayStyle,
        content: { ...modalStyle, ...style },
      }}
      ariaHideApp={false}
      onRequestClose={closeModal}>
      {children}
    </Modal>
  );
};

export default ModalWindow;
